import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const overdueVehicleUsageFilterSchema = z.object({
	search: optionalFilterString,
});
